import { NATIVE_EMBED_EXTENSION_KEY } from './manifest-helpers';

export const NATIVE_EMBED_MAUI_EXTENSION_KEY: string = `${NATIVE_EMBED_EXTENSION_KEY}:maui`;
